module.exports = __webpack_public_path__ + "static/media/blockchain_journey_bitcoin-studio.9a8b5743.jpg";